import {STEPS} from "../../../../constants";
import {appCall, appSetObj, appSetVal, completeSession} from "../../../../store/application";
import {getData} from "../../PhonereloadEzBill/models/transaction";
import {setLoadingContent} from "../../../../layouts/Content/modules/loadingContent";
import {changeStep} from "../../../../layouts/Content/modules/step";

export function submitTransaction(extraFields){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));
    dispatch(appSetVal('init_payment_done', false));

    //Get data by model
    const sessionData = getData(getStore, extraFields || []);
  
    if(!sessionData) return fail();

    //Set data to server session
    dispatch(appSetObj(sessionData, true));

    let result = await dispatch(appCall('validatePhoneNumber'));
    if(!(result && result.phone_number_validation && result.phone_number_validation.error === 0)) return fail();

    result = await dispatch(appCall('initPayment'));
    if(!result) return fail();

    return success();

    function success() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_success', true));
      dispatch(completeSession());
      return dispatch(changeStep(STEPS.SHOPPING_CART));
    }

    function fail() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_done', true));
      dispatch(appSetVal('init_payment_success', false));
      return false;
    }
  };
}


// WEBPACK FOOTER //
// ./src/components/Applications/PhonereloadEzBill/modules/ezbill.js